enum UnitSystem {
  Metric,
  Imperial,
}

export default UnitSystem;
